import React from "react";

const menus = [
  { key: "applications", label: "Applications" },
  { key: "designMaster", label: "Design Master" },
  { key: "estimateMaster", label: "District Estimate Master" },
  { key: "payments", label: "Payment & Accounts" },
  { key: "rnb", label: "R&B Verification" },
  { key: "engineer", label: "Engineer Progress" },
  { key: "ca", label: "CA Certificate" },
  { key: "registrar", label: "Registrar Approval" },
  { key: "accountsRegister", label: "Accounts Register" },
  { key: "workflowMonitor", label: "AI Workflow Monitor" },
];

export default function OfficeSchemeSidebar({ activeTab, setActiveTab }) {
  return (
    <aside className="w-72 min-h-screen bg-slate-950 text-white">
      <div className="p-5 border-b border-slate-700">
        <h2 className="text-xl font-bold">Office Scheme</h2>
        <p className="text-xs text-slate-300">Automation Dashboard</p>
      </div>

      <div className="p-4 space-y-2">
        {menus.map((m) => (
          <button
            key={m.key}
            type="button"
            onClick={() => setActiveTab(m.key)}
            className={`w-full text-left px-4 py-3 rounded-xl ${
              activeTab === m.key ? "bg-emerald-600" : "bg-slate-900"
            }`}
          >
            {m.label}
          </button>
        ))}
      </div>
    </aside>
  );
}